import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  showPrompt: true,
  personaliseQuoteShowFuel: true
};

export const slice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setInitialState: () => initialState,
    setShowPrompt: (state, { payload }) => {
      state.showPrompt = payload;
    },
    setPersonaliseQuoteShowFuel: (state, { payload }) => {
      state.personaliseQuoteShowFuel = payload;
    }
  }
});

export const {
  setShowPrompt,
  setInitialState,
  setPersonaliseQuoteShowFuel
} = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectShowPrompt = (state) => selectSlice(state).showPrompt;
export const selectPersonaliseQuoteShowFuel = (state) =>
  selectSlice(state).personaliseQuoteShowFuel;

export default slice.reducer;
